"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUPONS_WORDINGS = void 0;
exports.COUPONS_WORDINGS = {
    INFORMATION_BANNER: '<b>Information&nbsp;:&nbsp;</b>pensez à ajouter votre code promo à votre panier ou à votre commande en cours.',
};
exports.default = exports.COUPONS_WORDINGS;
//# sourceMappingURL=Coupons.js.map